
import classnames from "classnames";
import useBrandRouteGuard from "../use-brand-route-guard";

const GUIDE_STEPS = [
    { title: "Review amount owed", body: "Your dashboard shows the total owed to your publishers this cycle, broken down by publisher name." },
    { title: "Check your publishers", body: "The Publishers tab lists every publisher mapped to your account with their verification status and payout state." },
    { title: "Acknowledge the debit note", body: "When a debit note is raised, open Debit notes and acknowledge receipt. Approval unlocks once it is acknowledged." },
    { title: "Approve & settle offline", body: "Approve the note and transfer the total to the bank account shown on the document. Payouts to publishers are handled for you after settlement." },
    { title: "Watch KYC warnings", body: "Publishers with a pending verification are held. Their payout is released as soon as their KYC clears." }
];

const BrandGuide = () => {
    useBrandRouteGuard();

    return (
        <div className="p-6">
            <div className="flex items-end justify-between gap-4">
                <div>
                    <h1 className="text-2xl font-semibold tracking-tight">Brand user guide</h1>
                    <p className="text-sm text-muted">Close your payout cycle in a few steps.</p>
                </div>
            </div>

            <ol className="mt-6 space-y-3">
                {GUIDE_STEPS.map((step, idx) => {
                    return (
                        <li key={step.title} className="flex items-start gap-3 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
                            <div className="min-w-0">
                                <p className="text-[11px] font-semibold uppercase tracking-wider text-accent">Step {idx + 1}</p>
                                <p className={classnames("text-sm font-medium text-gray-900")}>
                                    {step.title}
                                </p>
                                <p className="mt-1 text-sm text-muted">{step.body}</p>
                            </div>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

export default BrandGuide;
